import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../ts/ServerApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../ts/ServerApi/types/IGetItemsResult';
import { IUser } from '../../../ts/ServerApi/types/IUser';
import { INamedItem, ITypedItem } from '../../../ts/ServerApi/types/resourceParts';
import { IDataRole } from '../types/IDataRole';

export interface IGetDataRolesParams extends IGetItemsParams {
}

export interface IGetDataRolesResult extends IGetItemsResult {
  dataRoles?: IDataRole[];
  users?: IUser[];
  projects?: INamedItem[];
  containers?: ITypedItem[];
  favorites?: string[];
}

export class GetDataRolesRequest extends Request<IGetDataRolesParams, IGetDataRolesResult> {
  constructor(params: IGetDataRolesParams) {
    super('getDataRoles', params);
  }
}
